export default function Suspended({ onSupport }: { onSupport?: () => void }) {
  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
          <i className="ri-error-warning-line text-red-500 text-2xl" />
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-3">
          Hesabınız geçici olarak incelemeye alındı
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-sm mx-auto">
          Güvenlik kontrolleri nedeniyle hesabınız destek ekibine yönlendirilmiştir. Bu bir güvenlik prosedürüdür ve kısa sürede çözümlenecektir.
        </p>

        <div className="space-y-3 mb-8">
          <button
            onClick={onSupport}
            className="w-full py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
          >
            Destek Talebi Oluştur
          </button>
          <a
            href="https://wa.me/905551234567"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-3.5 rounded-full text-sm font-semibold text-dark-teal-500 border border-dark-teal-500 hover:bg-dark-teal-50 transition-colors block"
          >
            <i className="ri-whatsapp-line mr-2" />
            WhatsApp Destek
          </a>
        </div>

        <p className="text-xs text-gray-400">
          Destek ekibimiz 7/24 hizmet vermektedir. Ortalama yanıt süresi 30 dakikadır.
        </p>
      </div>
    </div>
  );
}